"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Video", {
  enumerable: true,
  get: function () {
    return _Video.Video;
  }
});
Object.defineProperty(exports, "normalizeVideoUrlWithFragment", {
  enumerable: true,
  get: function () {
    return _utils.normalizeVideoUrlWithFragment;
  }
});
var _Video = require("./Video");
var _utils = require("./utils");
//# sourceMappingURL=index.js.map